// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6 1.5H10M8 1.5V4',
  'M13.25 9.25C13.25 12.15 10.9 14.5 8 14.5C5.1 14.5 2.75 12.15 2.75 9.25C2.75 6.35 5.1 4 8 4C10.9 4 13.25 6.35 13.25 9.25Z',
  'M8 9.25L10.25 7',
];
